import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 SELECTOR SEGMENTADO

    Mismo dato que un grupo de radios, distinta lectura: cuando las
    opciones son dos o tres y excluyentes, esto se entiende de un
    vistazo y ocupa una línea.
*/

export const FieldSegmented = ({
    id, name, label, hint, error, options = [],
    value, onChange, isFullWidth = true,
    isDisabled = false, span = 1,
}) => {

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
        isDisabled={isDisabled} span={span} >

        <div className={`${BLOCK}__segmented`} data-full={isFullWidth} role="radiogroup">
            {
                options.map((opt) => (
                    <button key={opt.value} type="button"
                        className={`${BLOCK}__segment`} data-on={value === opt.value}
                        role="radio" aria-checked={value === opt.value}
                        disabled={isDisabled || opt.isDisabled}
                        onClick={() => onChange?.({ target: { name: name ?? id, value: opt.value } })} >
                        {opt.icon}
                        {opt.label}
                    </button>
                ))
            }
        </div>

    </FieldShell>
);
};
